import React from 'react';
//@ts-ignore
import { nanoid } from 'nanoid/non-secure';
var OrganizationStructIcon = function OrganizationStructIcon() {
  var id = nanoid();
  var linearGradientId = "paint0_linear_".concat(id);
  return /*#__PURE__*/React.createElement("svg", {
    width: "26",
    height: "27",
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    y: "0.599976",
    width: "25.6",
    height: "25.6",
    rx: "4",
    fill: "#E6FFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0667 6.35199C10.0667 6.08198 10.2856 5.8631 10.5556 5.8631H15.4445C15.7145 5.8631 15.9334 6.08198 15.9334 6.35199V11.2409C15.9334 11.5109 15.7145 11.7298 15.4445 11.7298H13.7334V13.0144H19.5624V16.448H20.8223C21.0923 16.448 21.3112 16.6669 21.3112 16.9369V20.848C21.3112 21.118 21.0923 21.3369 20.8223 21.3369H16.9112C16.6412 21.3369 16.4223 21.118 16.4223 20.848V16.9369C16.4223 16.6669 16.6412 16.448 16.9112 16.448H18.0957V14.4811H13.7334V16.448H14.9556C15.2256 16.448 15.4445 16.6669 15.4445 16.9369V20.848C15.4445 21.118 15.2256 21.3369 14.9556 21.3369H11.0445C10.7745 21.3369 10.5556 21.118 10.5556 20.848V16.9369C10.5556 16.6669 10.7745 16.448 11.0445 16.448H12.2667V14.4811H7.90446V16.448H9.08896C9.35897 16.448 9.57785 16.6669 9.57785 16.9369V20.848C9.57785 21.118 9.35897 21.3369 9.08896 21.3369H5.17785C4.90785 21.3369 4.68896 21.118 4.68896 20.848V16.9369C4.68896 16.6669 4.90785 16.448 5.17785 16.448H6.43779V13.0144H12.2667V11.7298H10.5556C10.2856 11.7298 10.0667 11.5109 10.0667 11.2409V6.35199Z",
    fill: "url(#".concat(linearGradientId, ")")
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: linearGradientId,
    x1: "13.0001",
    y1: "5.8631",
    x2: "13.0001",
    y2: "21.3369",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CDBD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#13C2C2"
  }))));
};
export default OrganizationStructIcon;